// extracted by mini-css-extract-plugin
export default {"container":"style_container__8G2ge","content":"style_content__gNoxY","descWrapper":"style_descWrapper__T3jCw"};